import React from 'react';
import { toFixed } from 'humanize-plus';

import styles from './sellsideConsensusStyles';

import HoverOverTooltip from 'buyside/components/presentation/Tooltips/HoverOverTooltip/hoverOverTooltip';

import { inRange } from 'buyside/util/lodashAlt';

const SellsideConsensus = ({ sellsideConsensus }) => {
  return (
    <HoverOverTooltip
      overlay={[
        <div key="1" className={inRange(sellsideConsensus, 0.01, 1.24) ? styles.highlighted : ''}>
          0.0 - 1.24 <span className={styles.tooltipRight}>Buy</span>
        </div>,
        <div key="2" className={inRange(sellsideConsensus, 1.25, 1.74) ? styles.highlighted : ''}>
          1.25 - 1.74 <span className={styles.tooltipRight}>Overweight</span>
        </div>,
        <div key="3" className={inRange(sellsideConsensus, 1.75, 2.24) ? styles.highlighted : ''}>
          1.75 - 2.24 <span className={styles.tooltipRight}>Hold</span>
        </div>,
        <div key="4" className={inRange(sellsideConsensus, 2.25, 2.74) ? styles.highlighted : ''}>
          2.25 - 2.74 <span className={styles.tooltipRight}>Underweight</span>
        </div>,
        <div key="5" className={inRange(sellsideConsensus, 2.75, 3.0) ? styles.highlighted : ''}>
          2.75 - 3.0 <span className={styles.tooltipRight}>Sell</span>
        </div>
      ]}
    >
      {sellsideConsensus ? toFixed(sellsideConsensus, 2) : <span className={styles.na}>N/A</span>}
    </HoverOverTooltip>
  );
};

export default SellsideConsensus;
